/**
 * Created by hp on 2017/8/8.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ChannelPopularTitle from '../../images/yx-title.png';
import ChannelPopularBg from '../../images/yx-bg.png';
import '../../styles/channel/ChannelPopular.css';

class ChannelPopular extends Component {
    render() {
        const {prefferedReason} = this.props;

        return (
            <div className="channel-popular">
                <div className="cp-inner">
                    <p className="cp-title">
                        <img src={ChannelPopularTitle}/>
                    </p>
                    <div className="cp-content">
                        <p className="cpt-text">{prefferedReason}</p>
                        <p className="cpt-img">
                            <img src={ChannelPopularBg}/>
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    prefferedReason: state.channel.channel.preffered_reason,
}))(ChannelPopular)


// WEBPACK FOOTER //
// ./src/components/channel/ChannelPopular.js